import type { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import type { ISupplierAdmin } from '@bridebook/models/source/models/Suppliers/Admin/admin.types';
import type { IWedding } from '@bridebook/models/source/models/Weddings.types';
import { env } from '../env';
import { extractSupplier } from '../extract-supplier';
import { Gazetteer } from '../gazetteer';
import { getSupplierUrl, getUrlCoupleSideLocale } from '../getSupplierUrl';
import type {
  ISupplierListingPropertiesGeneric,
  ISupplierPropertiesGeneric,
  IWeddingPropertiesGeneric,
} from './types';

export const supplierPropertiesGeneric = (
  supplier: ISupplier,
  admin: ISupplierAdmin,
): ISupplierPropertiesGeneric => {
  const countryCode = supplier.l10n?.country;
  const countryName = countryCode ? Gazetteer.getCountryName(countryCode) : undefined;
  const { id: supplierId, type, name: supplierName } = supplier;

  return {
    supplierId,
    supplierCategory: type[0],
    supplierName,
    supplierTier: admin.premium?.tier || 0,
    countryCode,
    countryName,
  };
};

export const supplierListingPropertiesGeneric = (
  supplier: ISupplier,
): ISupplierListingPropertiesGeneric => {
  const {
    country: supplierCountry,
    countryCode,
    town: supplierTown,
    slug,
    venueType,
    postcode: supplierPostcode,
    website: supplierWebsite,
    county: supplierCounty,
    address: supplierAddress,
    email: supplierContactEmail,
    phone: supplierPhone,
    supplierRegistered,
  } = extractSupplier(supplier);

  const supplierLocale = getUrlCoupleSideLocale(countryCode);
  const supplierProfileURL = `${env.COUPLESIDE_URL}/${supplierLocale}${getSupplierUrl(supplier)}`;

  return {
    supplierAddress,
    supplierContactEmail,
    supplierCountry,
    supplierCounty,
    supplierPhone,
    supplierPostcode,
    supplierProfileURL,
    supplierTown,
    supplierWebsite,
    venueType: slug === 'venue' && venueType && venueType.length > 0 ? venueType[0] : undefined,
    supplierRegistered,
  };
};

export const weddingPropertiesGeneric = <
  T extends { partners: IWedding['partners']; id: IWedding['id'] },
>({
  partners,
  id: weddingId,
}: T): IWeddingPropertiesGeneric => ({
  weddingId,
  partners,
});
